var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTowing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.333,7.02V7.881L3,6.541,4.333,5.2V6.063H9.286a0.986,0.986,0,0,1,.857.766V9.7H11v0.861H7.476a1.449,1.449,0,0,1-.1.67,1.558,1.558,0,0,1-.667.67,1.659,1.659,0,0,1-1.333-.1,1.4,1.4,0,0,1-.571-0.766V10.561H3.571A0.692,0.692,0,0,1,3,9.987V8.36H6.143V7.02H4.333Zm3.143,0V8.36h1.81V7.02H7.476ZM6.429,10.274a0.493,0.493,0,0,0-.667.1,0.449,0.449,0,0,0,.1.574,0.476,0.476,0,0,0,.476,0A0.447,0.447,0,0,0,6.429,10.274ZM8.809,3V3.861H5.19V4.723H8.809V5.584l1.429-1.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowing);
export default __webpack_public_path__ + "static/media/towing.3711765b0b27f900d82e3f54ec4d639e.svg";
export { ForwardRef as ReactComponent };